module.exports = __webpack_public_path__ + "static/media/logo-credit.66a6b67a.svg";